module.exports = __webpack_public_path__ + "img/78.3f821517.jpg";